import { render, staticRenderFns } from "./NonInvestedFundCard.vue?vue&type=template&id=562db69a&scoped=true"
import script from "./NonInvestedFundCard.vue?vue&type=script&lang=js"
export * from "./NonInvestedFundCard.vue?vue&type=script&lang=js"
import style0 from "./NonInvestedFundCard.vue?vue&type=style&index=0&id=562db69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562db69a",
  null
  
)

export default component.exports